const typography = {
  errors: {
    pleaseRepeat: "Произошла ошибка. Попробуйте позже",
  },
  candidate: {
    form: {
      withTelegram: "Кандидат с Telegram-аккаунтом",
      withLogin: "Кандидат без Telegram-аккаунта",
    },
  },
  competencyMap: {
    archive: {
      disabled: "Нельзя переместить в архив: есть активные тестирования. Завершите их и попробуйте снова.",
      title: "Переместить карту компетенций в архив?",
      description:
        // eslint-disable-next-line max-len
        "Содержимое останется доступным для\u00A0редактирования. Запуск и\u00A0смена статуса будут недоступны. Все запланированные/ожидающие запуски будут остановлены.",
      confirm: "Переместить",
      buttonTitle: "Переместить в\u00A0архив",
    },
    recover: {
      title: "Восстановить карту компетенций?",
      confirm: "Восстановить",
    },
    statusChanged: "Статус карты компетенций изменен",
    deleted: "Карта компетенций удалена",
    knowledgeBlock: {
      deletionConfirm: "Вы уверены, что хотите удалить блок знаний?",
    },
  },
  form: {
    placeholder: {
      text: "Введите значение",
    },
  },
  testing: {
    table: {
      type: "Тип тестирования",
      assessmentType: "Вид тестирования",
      scoringType: "Вид оценки",
      aiGenerationPercentage: "Вероятность генерации с\u00A0помощью ИИ",
    },
  },
  rules: {
    min: (value: number | string) => `Значение должно быть больше или равно ${value}`,
    max: (value: number | string) => `Значение должно быть меньше или равно ${value}`,
  },
  // TODO: rolePlay, возможно переименовать после интеграции с бэком
  scenario: {
    title: "Ролевые сценарии",
    listTitle: "Список ролевых сценариев",
  },
  follow: "Перейти",
  write: "Написать",
} as const;

export default typography;
